import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { IDownloadRequest } from "../../interfaces/i-download-request";
import { IDownloadResponse } from "../../interfaces/i-download-response";

@Injectable({
  providedIn: "root",
})
export class DownloadCommunicatorService {
  private downloadRequestSubject = new Subject<IDownloadRequest>();

  public downloadRequest$ = this.downloadRequestSubject.asObservable();

  private downloadResponseSubject = new Subject<IDownloadResponse>();

  public downloadResponse$ = this.downloadResponseSubject.asObservable();

  pushDownloadResponse(response: IDownloadResponse) {
    this.downloadResponseSubject.next(response);
  }

  downloadImage(request: IDownloadRequest) {
    this.downloadRequestSubject.next(request);
  }
}
